import React from "react";
import { Context } from "../backend/context";

import { Link, withRouter } from "react-router-dom";
import { Redirect } from "react-router";
import { connect } from "react-redux";

function CreateBot(props) {
  const { isLoggedIn, user, api_key, alert } = React.useContext(Context);

  return (
    <div className="py-5 container text-left badge-dark">
      {!isLoggedIn || !user ? <Redirect to="/" /> : null}
      {api_key.length < 5 ? <Redirect to="/account" /> : null}
      {alert.isAvailable && (
        <div className="row">
          <div
            className={"col-11 m-auto text-center alert alert-" + alert.type}
          >
            {alert.msg}
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-12 h3 pt-3 text-center">Create New Bot</div>
      </div>
      <div className="row mt-5">
        <div className="col-6 col-sm-4 m-auto ">
          <Link
            to="/account/createbot/beginner"
            className="btn btn-lg btn-dark w-100 h-100 verticalCenter py-5"
            style={{ backgroundColor: "black" }}
          >
            Beginner
          </Link>
        </div>
        <div className="col-6 col-sm-4 m-auto ">
          <Link
            to="/account/createbot/advanced"
            className="btn btn-lg btn-dark w-100 h-100 verticalCenter py-5"
            style={{ backgroundColor: "black" }}
          >
            Advanced
          </Link>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-4 m-auto text-center verticalCenter">
          <Link
            to="/account"
            // type="submit"
            className="btn btn-secondary w-100"
          >
            Back
          </Link>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  botsCount: state.botsCount.botsCount,
});

export default withRouter(connect(mapStateToProps)(CreateBot));
